import IStorageProvider from '../services/storage/istorageProvider';

export enum StorageProviderKey {
  OneDrive = 'onedrive',
  Dropbox = 'dropbox',
  GoogleDrive = 'gdrive',
  /**
   * This browser, and nowhere else. Development builds only - see
   * services/storage/localStorageProvider.ts.
   */
  Local = 'local',
}

export const StorageProviderKeyToReadableName: {
  [P in StorageProviderKey]: string;
} = {
  [StorageProviderKey.Dropbox]: 'DropBox',
  [StorageProviderKey.GoogleDrive]: 'GoogleDrive',
  [StorageProviderKey.OneDrive]: 'OneDrive',
  [StorageProviderKey.Local]: 'This browser',
};

export type StorageProviderMap = {
  [P in StorageProviderKey]: React.MutableRefObject<IStorageProvider | undefined> | undefined;
};
